"use strict";

// ==============================================================
// Скрипт виджета опроса
// ==============================================================

(function ($) {
  "use strict";

  // check namespace
  $.b2b = $.b2b || {};
  var defaultOptions = {};

  // ReSharper disable once InconsistentNaming
  var PersonalQuizWidget = function PersonalQuizWidget() {
    var options = {
      itemsCount: null
    };
    var me;
    this.option = function (name, value) {
      if (name) {
        if (!value) {
          return options[name];
        }
        options[name] = value;
      }
    };
    this.centerModals = function centerModals() {
      var $clone = me.clone().css("display", "block").appendTo("body");
      var top = Math.round(($clone.height() - $clone.find(".modal-content").height()) / 2);
      top = top > 0 ? top : 0;
      $clone.remove();
      me.find(".modal-content").css("margin-top", top);
    };
    this.closeModal = function () {
      $.ajax({
        url: options.updateStatusUrl,
        type: "POST",
        cache: false
      });
    };
    this.init = function (opt) {
      options = $.extend({}, defaultOptions, opt);
      me = options.widget;
      if (options.hasData) {
        me.modal({
          backdrop: "static",
          keyboard: false,
          show: false
        }).on("show.bs.modal", this.centerModals).on("hide.bs.modal", this.closeModal);
        me.modal("show");
        $(window).on("resize", this.centerModals);
      }
    };
  };
  $.b2b.personalQuizWidget = new PersonalQuizWidget();
})(jQuery);